import { getContractBasedDataSelector } from '@cp-shared-19/frontend-integration';
import { RootState } from 'store/rootReducer';

export const ContractDetailsDataSelector = getContractBasedDataSelector((state: RootState) => state.contractDetails);
